import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Copyright, Scale } from 'lucide-react';

const AvisoLegal = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-red-100">
      {/* Header */}
      <div className="bg-white/95 backdrop-blur-md border-b border-red-200/50 sticky top-0 z-50 shadow-lg">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center space-x-2 text-red-600 hover:text-red-700 transition-colors">
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium">Volver a la tienda</span>
            </Link>
            <div className="flex items-center space-x-2">
              <img src="/icon.png" alt="Logo" className="w-8 h-8 object-contain" />
              <span className="text-xl font-bold text-gradient">Club Romerense</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Title */}
          <div className="text-center mb-12">
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="flex justify-center mb-6"
            >
              <div className="bg-gradient-to-r from-red-600 to-red-800 p-4 rounded-full">
                <Scale className="w-12 h-12 text-white" />
              </div>
            </motion.div>
            <h1 className="text-4xl md:text-5xl font-bold text-gradient mb-4">Aviso Legal</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Información legal sobre el sitio web romerenseoficial.com y su tienda comercial
            </p>
          </div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white rounded-lg shadow-xl p-8 md:p-12"
          >
            {/* Section 1 */}
            <div className="mb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="bg-red-100 p-3 rounded-full">
                  <Copyright className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    1. Titularidad de los Derechos de la Página Web
                  </h2>
                </div>
              </div>
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                <p className="mb-4">
                  El sitio web <strong>romerenseoficial.com</strong>, incluyendo su tienda comercial y la aplicación de gestión integrada, es propiedad del <strong>Club Deportivo y Biblioteca Popular Romerense</strong>. Todos los derechos de propiedad intelectual sobre los contenidos, diseño, estructura, y funcionalidades del sitio web están protegidos por la Ley No. 11.723 de Propiedad Intelectual de la República Argentina y tratados internacionales de derechos de autor suscriptos por Argentina, como el Convenio de Berna.
                </p>
                <p className="mb-4">
                  <strong>Club Deportivo y Biblioteca Popular Romerense</strong> se reserva todos los derechos sobre el sitio web, incluyendo, pero no limitándose a, los derechos de reproducción, distribución, comunicación pública y transformación. Queda estrictamente prohibida cualquier copia, reproducción, distribución o uso no autorizado de cualquier elemento de este sitio web, ya sea por personas físicas o jurídicas, sin el consentimiento expreso y por escrito del Club Deportivo y Biblioteca Popular Romerense.
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="bg-red-100 p-3 rounded-full">
                  <Shield className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    2. Derechos de Desarrollo y Funcionalidad
                  </h2>
                </div>
              </div>
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                <p className="mb-4">
                  Los derechos de desarrollo y funcionalidad de la página web <strong>romerenseoficial.com</strong>, incluyendo los sistemas, aplicaciones y características técnicas que componen la tienda comercial y la aplicación de gestión integrada, son propiedad de <strong>Reta Lucas (CUIL: 20-32312637-3)</strong> y <strong>Albarengo Guillermo (CUIL: 23-32308476-9)</strong>, quienes han cedido el derecho de uso y funcionalidad de dichas características al Club Deportivo y Biblioteca Popular Romerense para su explotación en el marco de este sitio web.
                </p>
                <p className="mb-4">
                  <strong>Albarengo Guillermo</strong> y <strong>Reta Lucas</strong> conservan los derechos morales y patrimoniales sobre las funcionalidades desarrolladas, conforme a lo estipulado en la Ley No. 11.723. En caso de que cualquier persona física o jurídica replique, copie o utilice las funcionalidades técnicas de esta plataforma en otra plataforma sin el consentimiento expreso y por escrito de Albarengo Guillermo y Reta Lucas, estos se reservan el derecho de iniciar las acciones legales correspondientes por infracción de derechos de autor.
                </p>
              </div>
            </div>

            {/* Section 2 bis */}
            <div className="mb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="bg-red-100 p-3 rounded-full">
                  <Shield className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    2 bis. Uso Exclusivo del Logotipo y Penalidades Legales
                  </h2>
                </div>
              </div>
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                <p className="mb-4">
                  El logotipo oficial del <strong>Club Deportivo y Biblioteca Popular Romerense</strong>, junto con sus elementos gráficos distintivos, constituye una marca registrada y una obra protegida por la Ley N.º 11.723 de Propiedad Intelectual y la Ley N.º 22.362 de Marcas de la República Argentina.
                </p>
                <p className="mb-4">
                  El uso del logotipo queda estrictamente reservado al Club y a su comercialización exclusiva a través de la tienda oficial. Cualquier reproducción, uso no autorizado o distribución del mismo será considerado una infracción de derechos.
                </p>
                <p className="mb-4">
                  Las personas físicas o jurídicas que incurran en dichas infracciones podrán ser objeto de acciones legales civiles y penales conforme a la legislación vigente. Entre las sanciones aplicables se encuentran la indemnización por daños y perjuicios, el retiro inmediato del material infractor y penas de hasta seis (6) años de prisión, según lo dispuesto en el Código Penal Argentino.
                </p>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="bg-red-100 p-3 rounded-full">
                  <Scale className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    3. Acciones Legales por Infracción
                  </h2>
                </div>
              </div>
              
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                <p className="mb-4">
                  <strong>Club Deportivo y Biblioteca Popular Romerense</strong>, así como <strong>Albarengo Guillermo</strong> y <strong>Reta Lucas</strong>, se reservan el derecho de iniciar acciones legales contra cualquier persona física o jurídica que infrinja los derechos de propiedad intelectual aquí establecidos. Esto incluye, pero no se limita a, la reproducción no autorizada de contenidos, el uso indebido de funcionalidades, o cualquier forma de copia o replicación de la plataforma romerenseoficial.com.
                </p>
                
                <p className="mb-4">
                  Las acciones legales se llevarán a cabo conforme a lo dispuesto por la Ley No. 11.723 de Propiedad Intelectual de Argentina, así como por los tratados internacionales de copyright aplicables. Las sanciones por infracción pueden incluir multas, medidas cautelares, y la obligación de indemnizar por daños y perjuicios.
                </p>
              </div>
            </div>

            {/* Section 4 */}
            <div className="mb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="bg-red-100 p-3 rounded-full">
                  <Copyright className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    4. Contacto
                  </h2>
                </div>
              </div>
              
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                <p className="mb-4">
                  Para cualquier consulta relacionada con este aviso legal o para solicitar autorización para el uso de los contenidos o funcionalidades de este sitio web, por favor contacte al Club Deportivo y Biblioteca Popular Romerense a través de <strong>galbarengo@romerenseoficial.com</strong>.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="border-t border-gray-200 pt-8 mt-12">
              <div className="text-center">
                <div className="flex justify-center items-center space-x-2 mb-4">
                  <img src="/icon.png" alt="Logo" className="w-8 h-8 object-contain" />
                  <span className="text-xl font-bold text-gradient">Club Romerense</span>
                </div>
                <p className="text-gray-600">
                  © 2024 Club Deportivo y Biblioteca Popular Romerense. Todos los derechos reservados.
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  Desarrollado por Reta Lucas y Albarengo Guillermo
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default AvisoLegal;
